<template>
  <div class="video-upload">
    <MediaUpload
      class="video-upload-media"
      ref="uploader"
      :maxSize="maxSize"
      :sizeTip="sizeTip"
      :maxSpace="maxSpace"
      typeTip="请上传H264标准的mp4文件"
      accept="video/mp4"
      @updateState="updateState"
      @uploadSuccess="uploadSuccess"
      @uploadError="uploadError"
      @updatePercentage="updatePercentage"
      @toSpace="toSpace"
    >
      <!-- <img class="button-upload-img" src="@imgs/upload_video.png" @click="beforeUpload($event)" /> -->
    </MediaUpload>
    <div class="video-upload-button-wrapper" v-show="uploadState === 'ready'"><img class="button-upload-img" src="@imgs/upload_video.png" @click="beforeUpload" /></div>
    <UploadProgress v-show="uploadState === 'uploading'" :percentage="percentage" title="方正云阅读制作" message="上传视频"></UploadProgress>
    <TipDialog ref="spaceDialog" :dialogOptions="spaceDialogOptions" @clickCancel="buySpaceCancel" @clickConfirm="clickBuySpace"></TipDialog>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
  </div>
</template>

<script>
import TcVod from 'vod-js-sdk-v6'
import { setVideoInfo } from '@api/video.js'
import UploadProgress from '@components/uploadContent/uploadProgress'
import TipDialog from '@components/common/TipDialog.vue'
import MediaUpload from '@components/common/MediaUpload.vue'
import compareVipRight from '@components/common/compareVipRight.js'
import { getVideoList } from '@api/video'
import { getProductsCount } from '@api/getBook'

export default {
  name: 'VideoUpload',
  mixins: [compareVipRight],
  data() {
    return {
      tcVod: null,
      uploadState: 'ready',
      percentage: 0,
      uploaderInfo: '',
      resultInfo: '',
      spaceDialogOptions: {
        // 弹框类型
        type: 'buySpace',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '您可用空间不足，请进行空间扩容'
      }
    }
  },
  computed: {
    memberDialogOptions() {
      return {
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，仅允许创建${this.$store.state.common.vipRight.videoNum}个视频，创建更多需先升级会员服务。`
      }
    },
    maxSize() {
      return this.$store.state.common.vipRight.videoSize || 100
    },
    sizeTip() {
      return `视频大小不能超过${this.maxSize}M`
    },
    isSubAccount() {
      return this.$store.state.common.isSubAccount
    },
    userName() {
      return localStorage.getItem('username')
    },
    alreadyUse() {
      return this.$store.state.manage.alreadyUse || 0
    },
    totalSpace() {
      return this.$store.state.manage.allSpace
    },
    maxSpace() {
      return this.totalSpace * 1024 - this.alreadyUse
    }
  },
  methods: {
    updateState: function(state) {
      this.uploadState = state
      this.$emit('updateUploadingStatus', state)
      if (state === 'ready') {
        this.percentage = 0
      }
    },
    updatePercentage: function(percent) {
      this.percentage = Math.round(percent * 10000) / 100
    },
    uploadSuccess: function(uploaderInfo) {
      setVideoInfo(uploaderInfo).then((res) => {
        if (res.status == 200) {
          if (res.data.code == 0) {
            this.$router.push({ name: 'list', params: { to: 'video' } })
          } else if (res.data.code == 1) {
            if (res.data.msg.includes('请进行空间扩容')) {
              this.$refs.spaceDialog.visible = true
            } else {
              this.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定',
                callback: (action) => {
                  if (action === 'confirm') {
                    this.$refs.uploader.cancel()
                  }
                }
              })
            }
          }
        } else {
          this.$alert(res.data.msg, '提示', {
            confirmButtonText: '确定',
            callback: (action) => {
              if (action === 'confirm') {
                this.$refs.uploader.cancel()
              }
            }
          })
        }
        this.uploadState = 'ready'
      })
    },
    uploadError: function(err) {
      // deal with error
      this.$alert('上传失败', '提示', {
        confirmButtonText: '确定'
      })
    },
    clickBuySpace() {
      this.percentage = 0
      if (this.uploader) {
        this.uploader.cancel()
      }
      this.$router.push({
        path: '/openVIP',
        query: {
          dilatation: 1
        }
      })
    },
    buySpaceCancel() {
      this.percentage = 0
      if (this.uploader) {
        this.uploader.cancel()
      }
    },
    async beforeUpload(e) {
      const isLogin = await this.$store.dispatch('common/login')
      if (!isLogin) {
        return
      }
      await this.getVipInfo()
      await this.$store.dispatch('manage/getSpace')
      const param = {
        userName: this.userName,
        isChild: this.isSubAccount,
        type: 'video'
      }
      await getProductsCount(param).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          this.totalCount = res.data.data.sum
        }
      })
      if (!this.compare({ type: 'num', key: 'videoNum', value: this.totalCount })) {
        this.$refs.memberDialog.visible = true
      } else {
        this.$refs.uploader.addMedia()
      }
    },
    getVideos() {
      const param = {
        pageNo: 1,
        pageSize: 11
      }
      getVideoList(param).then((res) => {
        if (res && res.status == 200 && res.data.page) {
          this.totalCount = res.data.page.totalCount
        }
      })
    },
    toSpace() {
      this.$refs.spaceDialog.visible = true
    }
  },

  components: {
    UploadProgress,
    TipDialog,
    MediaUpload
  },
  mounted() {
    this.tcVod = new TcVod({
      getSignature: this.getSignature
    })
    this.getVipInfo()
    this.getVideos()
  }
}
</script>

<style lang="scss" scoped>
.video-upload {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
  .upload-input {
    display: none;
  }
  .video-upload-media {
    width: 0;
    height: 0;
  }
  .video-upload-button-wrapper {
    width: 250px;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .button-upload-img {
      width: 100%;
    }
  }
}
</style>
